import React from "react";
import "./reviews.css";

const Review = ({ review }) => {
	const generateStars = (rating) => {
		return "⭐".repeat(rating); // По-чист начин за генериране на звезди
	};

	return (
		<div className={`review ${!review.authorImage ? "no-image" : ""}`}>
			{/* Рендерираме целия контейнер САМО ако има снимка */}
			{review.authorImage && (
				<div className="author-image">
					<img src={review.authorImage} alt={review.author} />
				</div>
			)}

			<div className="review-content">
				<p className="comment">“{review.comment}”</p>
				<div className="review-footer">
					<div className="stars">{generateStars(review.rating)}</div>
					<p className="review-author-name">{review.author}</p>
					{review.occupation && (
						<p className="review-author-occupation">{review.occupation}</p>
					)}
				</div>

			</div>
		</div>
	);
};

export default Review;

/*
import React from "react";
import "./reviews.css";

const Review = ({ review }) => {
	const generateStars = (rating) => {
		const stars = [];
		for (let i = 0; i < rating; i++) {
			stars.push("⭐"); // Unicode star character
		}
		return stars;
	};

	return (
		<div className="review">
			<div className="author-image">
				{review.authorImage && (
					<img src={review.authorImage} alt={`showing ${review.author}`} />
				)}
			</div>
			<p>{review.comment}</p>
			<p className="rating">{generateStars(review.rating).join(" ")}</p>
			<p className="review-author-name">{review.author}</p>
			<p className="review-author-occupation">{review.occupation}</p>
		</div>
	);
};

export default Review;
*/
